/**
 * Loop Cart Drawer Observer
 * Watches for cart drawer changes and hides bundle options in subscription dropdowns
 */
document.addEventListener('DOMContentLoaded', () => {
  const intervalId = setInterval(checkCartDrawerStatus, 10);
  
  function checkCartDrawerStatus() {
    const targetNode = document.getElementById('CartPopup');
    // console.log("loop targetNode", targetNode)
    if (targetNode) {
      clearInterval(intervalId);
      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };
      // Callback function to execute when mutations are observed
      const callback = function(mutationsList, observer) {
        for(const mutation of mutationsList) {
          if (mutation.type === 'childList') {
              // console.log('A child node has been added or removed.');
          }
          else if (mutation.type === 'attributes') {
              // console.log(`The ${mutation.attributeName} attribute was modified.`);
          }
          helper();
        }
      };
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);
      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
      // To stop observing:
      // observer.disconnect();
    }
  }
  
  function helper(){
    // console.log("drawer opened")
    const subscriptionOptGroups = document.querySelectorAll('.upcart-subscription-upgrade-dropdown optgroup[label="Subscription plans"]');
    // Loop through each optgroup
    subscriptionOptGroups.forEach(optGroup => {
      // Get all options within the current optgroup
      const options = optGroup.querySelectorAll('option');
      // Loop through each option and hide those with "Subscribe & Save"
      options.forEach(option => {
          if (option.textContent.includes('Bundle')) {
              option.style.display = 'none';
          }
      });
    });
  }
});

